import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingMedicalRecordSectionConfig,
    deleteMedicalRecordSectionConfig,
    saveOrUpdateMedicalRecordSectionConfig,
    getMedicalRecordSectionConfigById,
    getAllMedicalRecordSectionConfig
} from 'app/services/MedicalRecordSectionConfigService';

import { MedicalRecordSectionConfig } from "app/common/Model/MedicalRecordSectionConfig";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class MedicalRecordSectionConfigStore {
    listAllMedicalRecordSectionConfig = [];
    searchMedicalRecordSectionConfig = new SearchObject();
    pageMedicalRecordSectionConfig = null;
    selectedMedicalRecordSectionConfig = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteMedicalRecordSectionConfig = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllMedicalRecordSectionConfig = () => {
        if (this.listAllMedicalRecordSectionConfig?.length === 0) {
            pagingMedicalRecordSectionConfig({ pageIndex: 1, pageSize: PAGESIZE_ALL }).then(({ data }) => {
                this.listAllMedicalRecordSectionConfig = data.content;
            })
        }
    }

    pagingMedicalRecordSectionConfig = () => {
        pagingMedicalRecordSectionConfig(this.searchMedicalRecordSectionConfig).then(({ data }) => {
            this.pageMedicalRecordSectionConfig = data;
        })
    }

    handleChangeFormSearch = (searchMedicalRecordSectionConfig) => {
        this.searchMedicalRecordSectionConfig = checkSearchObject(this.searchMedicalRecordSectionConfig, searchMedicalRecordSectionConfig);
        this.pagingMedicalRecordSectionConfig();
    }

    handleOpenFormCreateOrEdit = (medicalRecordSectionConfigById) => {
        if (Boolean(medicalRecordSectionConfigById)) {
            getMedicalRecordSectionConfigById(medicalRecordSectionConfigById).then(({ data }) => {
                const transformedFields = data?.fields?.map(field => (
                    {
                        ...field,
                        concept: field?.concept,
                        type: field?.type
                    }
                ));

                this.selectedMedicalRecordSectionConfig = {
                    ...data,
                    fields: transformedFields
                };
                console.log(this.selectedMedicalRecordSectionConfig)
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedMedicalRecordSectionConfig = new MedicalRecordSectionConfig();
            this.openFormCreateOrEdit = true;
        }
    }

    saveMedicalRecordSectionConfig = (medicalRecordSectionConfig) => {
        saveOrUpdateMedicalRecordSectionConfig(medicalRecordSectionConfig).then(() => {
            this.selectedMedicalRecordSectionConfig = null;
            toast.success("Lưu kiểu thăm khám thành công!");
            this.pagingMedicalRecordSectionConfig();
            this.handleClosePopup();
            this.listAllMedicalRecordSectionConfig = [];
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu kiểu thăm khám thất bại!");
        }) 
    }

    handleDeleteMedicalRecordSectionConfig = (medicalRecordSectionConfig) => {
        this.selectedMedicalRecordSectionConfig = { id: medicalRecordSectionConfig?.id };
        this.openConfirmDeleteMedicalRecordSectionConfig = true;
    }

    handleConfirmDeleteMedicalRecordSectionConfig = () => deleteMedicalRecordSectionConfig(this.selectedMedicalRecordSectionConfig?.id)
        .then(() => {
            if (this.searchMedicalRecordSectionConfig?.pageIndex > 1 && this.pageMedicalRecordSectionConfig?.content?.length === 1) {
                this.searchMedicalRecordSectionConfig.pageIndex -= 1;
            }
            toast.success("Xóa kiểu thăm khám thành công!");
            this.pagingMedicalRecordSectionConfig();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa kiểu thăm khám thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalRecordSectionConfig = false;
    }

    resetStore = () => {
        this.searchMedicalRecordSectionConfig = new SearchObject();
        this.pageMedicalRecordSectionConfig = null;
        this.selectedMedicalRecordSectionConfig = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalRecordSectionConfig = false;
    }
}